import Popover from "./Popover";
import Tooltip from "./Tooltip";
import {TooltipVariant} from "./interfaces";

export default Tooltip;
export {TooltipVariant, Popover};
